// src/api/invites.js
import axiosInstance from "../helpers/axiosInstance";

const API_ROOT = "/bucket-list"; // prefix from your Flask blueprint

export const sendInvite = (tripId, email, resourceTypes) =>
  axiosInstance.post(`${API_ROOT}/${tripId}/sent-invite`, {
    email,
    resource_types: resourceTypes,
  });

export const pendingInvites = () =>
  axiosInstance.get(`${API_ROOT}/invites/pending`);

export const pendingInvitesCount = () =>
  axiosInstance.get(`${API_ROOT}/invites/count`);

export const acceptInvite = (inviteId) =>
  axiosInstance.put(`${API_ROOT}/invites/${inviteId}/accept`);

export const rejectInvite = (inviteId) =>
  axiosInstance.put(`${API_ROOT}/invites/${inviteId}/reject`);

export const sentInvites = (tripId) =>
  axiosInstance.get(`${API_ROOT}/${tripId}/invites`);

export const tripUsersStatus = (tripId) =>
  axiosInstance.get(`${API_ROOT}/${tripId}/users-status`);

export const getAvailableResources = (tripId) =>
  axiosInstance.get(`${API_ROOT}/${tripId}/available-resources`);

export const removeUserFromResource = (tripId, user_email, resource_type) =>
  axiosInstance.delete(`${API_ROOT}/${tripId}/remove-user-resource`, {
    data: { user_email, resource_type },
  });

export const leaveResource = (tripId, resourceType) =>
  axiosInstance.delete(
    `${API_ROOT}/${tripId}/leave-resource`,
    { data: { resource_type: resourceType } } // 👈 body goes here
  );

export const addUserToResource = (tripId, user_email, resource_type) =>
  axiosInstance.post(`${API_ROOT}/${tripId}/add-user-to-resource`, {
    user_email,
    resource_type,
  });
